import { render, staticRenderFns } from "./gongShang.vue?vue&type=template&id=5c5843cc&scoped=true"
import script from "./gongShang.vue?vue&type=script&lang=js"
export * from "./gongShang.vue?vue&type=script&lang=js"
import style0 from "./gongShang.vue?vue&type=style&index=0&id=5c5843cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5843cc",
  null
  
)

export default component.exports